
      var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExclamationMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60 14.2c25.252 0 45.8 20.548 45.8 45.8S85.252 105.8 60 105.8 14.2 85.252 14.2 60 34.748 14.2 60 14.2Z",
  stroke: "#000",
  strokeWidth: 4.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.65 37.828 60 69.561l2.35-31.733a2.357 2.357 0 1 0-4.7 0Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 82.5,
  r: 4.5,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M60 14.2002C85.2517 14.2002 105.8 34.7483 105.8 60C105.8 85.2517 85.2517 105.8 60 105.8C34.7483 105.8 14.2002 85.2517 14.2002 60C14.2002 34.7483 34.7483 14.2002 60 14.2002Z\" stroke=\"#000000\" stroke-width=\"4.4\"/>\r\n<path d=\"M57.6497 37.828L60.0002 69.561L62.3508 37.828C62.4521 36.4614 61.3706 35.2969 60.0002 35.2969C58.6299 35.2969 57.5484 36.4614 57.6497 37.828Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"60\" cy=\"82.5\" r=\"4.5\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/exclamationMark.ffd3e52ef1004aef86b34d42c3802126.svg"),
        {
          React: SvgExclamationMark,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      